var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceOrientationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.000000 281.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,281.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630 2800 c-433 -5 -446 -6 -486 -27 -49 -26 -111 -92 -121 -130 -5 -16 -8 -575 -8 -1243 l0 -1215 22 -40 c25 -47 64 -85 113 -111 33 -18 68 -19 605 -19 l570 0 45 25 c52 29 105 95 120 148 14 53 14 2383 -1 2437 -25 93 -110 159 -217 171 -91 9 -130 10 -642 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748 2581 c-58 -44 -108 -87 -112 -97 -8 -20 13 -53 103 -166 64 -81 85 -92 114 -60 24 26 22 32 -24 95 -22 32 -35 57 -30 57 6 0 52 -13 103 -30 166 -53 301 -144 411 -275 56 -67 139 -218 153 -279 l7 -29 -66 36 c-71 40 -98 45 -117 22 -27 -32 -4 -58 113 -127 62 -38 123 -68 134 -68 17 0 36 25 87 111 66 111 77 144 54 167 -26 26 -56 14 -84 -33 -25 -44 -44 -58 -44 -32 0 7 -16 45 -35 86 -134 278 -357 456 -674 538 l-34 8 51 40 c35 26 52 46 52 61 0 25 -24 54 -44 54 -7 0 -60 -36 -118 -79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652 1488 c-7 -7 -12 -25 -12 -40 0 -20 6 -29 23 -33 12 -3 230 -6 484 -8 449 -2 462 -3 490 -23 47 -34 63 -79 63 -171 0 -82 0 -83 -26 -83 -14 0 -34 -5 -45 -10 -18 -10 -19 -25 -19 -358 0 -257 3 -351 12 -360 7 -7 27 -12 46 -12 l34 0 -4 -99 c-3 -90 -5 -102 -28 -126 -53 -56 -37 -55 -588 -55 -490 0 -510 -1 -526 -19 -23 -25 -13 -59 21 -72 34 -13 955 -12 1024 1 72 14 123 49 159 113 l30 52 0 570 c0 530 -2 573 -19 610 -23 51 -89 111 -138 124 -57 16 -965 15 -981 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOrientationIcon);
export default __webpack_public_path__ + "static/media/device_orientation_icon.a585f23a.svg";
export { ForwardRef as ReactComponent };